export default {
  fontFamily: "en-font-family",
  classLang: "en",
  headlist: [
    // {
    //   text: "홈",
    //   url: "/",
    // },
    {
      text: "거래",
      menu: [
         {
          tit: "거래 상품",
          list: [
            {
              text: "외환 거래",
              url: "/tradingproduct?index=0",
            },
            {
              text: "コモディティ",
              url: "/tradingproduct?index=1",
            },
            {
              text: "주가 지수",
              url: "/tradingproduct?index=2",
            },
            {
              text: "미국 주식",
              url: "/tradingproduct?index=3",
            },
            {
              text: "ETF",
              url: "/tradingproduct?index=4",
            },
          ],
        },
        {
          tit: "거래 관련",
          list: [
            {
              text: "거래계좌",
              url: "/TradingAccount",
            },
            // {
            //   text: "거래 상품",
            //   url: "/tradingproduct",
            // },
            {
              text: "레버리지 & 마진",
              url: "/leverage-margin",
            },
            {
              text: "입출금",
              url: "/funding",
            },
            {
              text: "배당금",
              url: "/dividend",
            },{
              text: "기관 서비스",
              url: "/service",
            },
            {
              text: "핀테크",
              url: "/technology",
            },
          ],
        },
        {
          tit: "거래 도구",
          list: [
            {
              text: "MT4 다운로드",
              url: "/MT4",
            },
            {
              text: "MT5 다운로드",
              url: "/MT5",
            },
            {
              text: "EA 거래 및 지표",
              url: "/tools",
            },
            {
              text: "PAMM",
              url: "/PAMM",
            },
            {
              text: "시장 분석",
              url: "/market-analysis",
            },
          ],
        },
      ],
    },
    {
      text: "EBC 연구소",
      menu: [
        {
          tit: "",
          list: [
            {
              text: "교육 중심",
              url: "/LearningCenter",
            },
            {
              text: "데이터 중심",
              url: "/lab",
            },
          ],
        },
      ],
    },

    {
      text: "EBC 소개",
      menu: [
        {
          tit: "EBC 소개",
          list: [
            {
              text: "WHY EBC",
              url: "/about-us",
            },
            {
              text: "EBC 뉴스",
              url: "/ESG",
            },
           
            {
              text: "EBC 뉴스",
              url: "/LearningCenter?tabId=1",
            },
             {
              text: "FAQ",
              url: "https://support.ebchelp.com/hc/en-001",
            },
            {
              text: "공식 채널 인증",
              url: "/official-verification",
            },
          ],
        },
        {
          tit: "협력 모드",
          list: [
            {
              text: "FC 바르셀로나",
              url: "/FCB",
            },
            {
              text: " 옥스퍼드 대학",
              url: "/partners/oxford",
            },
            {
              text: "제휴 프로그램",
              url: "/affiliate-programmes",
            },
            // {
            //   text: "기관 서비스",
            //   url: "/service",
            // },
            // {
            //   text: "핀테크",
            //   url: "/technology",
            // },
          ],
        },
      ],
    },
    {
      text: "최신 이벤트",
      url: "",
      menu: [
        {
          tit: "EBC 인기 이벤트",
          list: [
            {
              text: "EBC 백만 달러 실거래 대회 Ⅱ",
              url: "/million-dollar-challenge-2",
            },
            
            {
              text: "펀드매니저 프로그램",
              url: "/pay",
            },{
              text: "他のキャンペーン",
              url: "/activity",
            },
           
          ],
        },
      ],
    },
  ],
  FCA开户: "FCA계좌개설",
  立即开户: "회원가입",
  登录: "로그인",
  官方验证: "공식 채널 인증",
  帮助中心: "FAQ",
  帮助中心Url: "https://support.ebchelp.com/hc/en-001",
};
